import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class DirectorProctoringConfigModel extends Model {
  constructor(
    public useMultiMonitorProctor: boolean = false,
    public useTabSwitchProctor: boolean = false,
    public useCopyPasteProctor: boolean = false,
    public useScreenRecording: boolean = false,
    public useShortcutProctor: boolean = false,
    public agreeOnScreenRecording: boolean = false
  ) {
    super();
  }

  public static create(model: Partial<DirectorProctoringConfigModel>): DirectorProctoringConfigModel {
    return createModel<DirectorProctoringConfigModel>(DirectorProctoringConfigModel, {
      ...model
    });
  }
}
